/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-07-02T17:43:04.074
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import BasicLayout from '@/layouts/basic-layout';

const meta = {
auth: true
};

const pre = 'report-reportfinancialrentcontractitempaymentmonth-'

export default 
{
path: '/report/reportfinancialrentcontractitempaymentmonth',
name: 'report-reportfinancialrentcontractitempaymentmonth',
redirect: {
name: '${pre}-index'
}
,

meta:{
...meta,
},

component: BasicLayout ,
children:
[
{
path: 'index',
name: '${pre}reportfinancialrentcontractitempaymentmonth-index',

meta:{
...meta,
title: '应收报表（月）'
},

component: () => import('@/pages/report/reportfinancialrentcontractitempaymentmonth/index') ,
},
{
path: 'detail-edit/:id',
name: '${pre}reportfinancialrentcontractitempaymentmonth-detail-edit',
auth: [
'hidden'
],

meta:{
...meta,
title: '应收报表（月）编辑'
},

component: () => import('@/pages/report/reportfinancialrentcontractitempaymentmonth/detail-edit') ,
},
{
path: 'detail-edit',
name: '${pre}reportfinancialrentcontractitempaymentmonthdetail-create',
auth: [
'hidden'
],

meta:{
...meta,
title: '应收报表（月）新增'
},

component: () => import('@/pages/report/reportfinancialrentcontractitempaymentmonth/detail-edit') ,
},
{
path: 'detail-view/:id',
name: '${pre}reportfinancialrentcontractitempaymentmonthView',
auth: [
'hidden'
],

meta:{
...meta,
title: '应收报表（月）详情查看'
},

component: () => import('@/pages/report/reportfinancialrentcontractitempaymentmonth/detail-view') ,
},
]
};
